import { track } from '@front/logic/segment'
import { getAnalytics } from '@front/logic/segment/global.analytics'

export const useHublerContractTracking = (
  event: string,
  contractId: string,
  shiftId: number,
) => {
  if (!contractId || !shiftId) {
    return () => undefined
  }

  return () => {
    track(
      event,
      {
        category: 'Hubler Contract',
        contractId: [contractId],
        shiftId: [shiftId.toString()],
      },
      getAnalytics(),
    )
  }
}
